export interface QuickBooksDashboardProps {
    // Props passed from Blazor
}

export const QuickBooksComponent = {
    MountAsync: async (target: HTMLElement, props: QuickBooksDashboardProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { QuickBooksDashboard } = await import('./QuickBooksDashboard');
        return await mountReactComponentAsync(target, QuickBooksDashboard, props);
    }
};
